import { Result } from '~/types/api/result'
export interface Service {
  displayOperator(result: Result): boolean
  about: string
  name: string
  catch: string
  description: string
  actionName: string
  url: string
}

const isFemaleAssignedAtBirth = (result: Result): boolean => {
  return result.sex.gender.id === 'female'
}

const isFemaleLeaningGenderIdentity = (result: Result): boolean => {
  return result.genderIdentity.gender.score > 50
}

const isGenderIdentityButtonAnswer = (result: Result): boolean => {
  return ['genderfluid', 'xgender_agender', 'xgender_bigender', 'questioning'].includes(result.genderIdentity.gender.id)
}

const shouldDisplayPiamy = (result: Result): boolean => {
  return isFemaleAssignedAtBirth(result) && (isFemaleLeaningGenderIdentity(result) || isGenderIdentityButtonAnswer(result))
}

export const SERVICES: Service[] = [
  {
    displayOperator(_: Result): boolean {
      return true
    },
    name: 'diversity',
    about: '日本初！多様性について学び、実践するための検定',
    catch: 'D&I検定（ダイバーシティ&インクルージョン検定）',
    description:
      '既に54,000名が受検！ 自分の「多様性」に気づいたら、次の一歩を踏み出しませんか？' +
      'LGBTQ+、障害、多文化、ジェンダーなどへの理解は、これからの時代の必須スキル。実践的な知識・履歴書に書ける強みが手に入る、日本初の検定です。',
    actionName: '詳しく見る',
    url: 'https://dikentei.com/individual',
  },
  {
    displayOperator(_: Result): boolean {
      return true
    },
    name: 'jobrainbow',
    about: '自分らしく働きたいあなたへ',
    catch: 'No.1ダイバーシティ就職情報サイト<wbr />「ジョブレインボー」',
    description:
      'セクシュアリティ、ジェンダー、国籍、障害の有無、育児・介護などのライフステージに関わらず、誰もが自分らしく働ける環境づくり（DEI推進）に取り組む企業だけを厳選した就活・転職情報サイトです。',
    actionName: '求人を見る（無料）',
    url: 'https://jobrainbow.jp/?utm_source=discover_sexualities&utm_medium=discover_sexualities&utm_campaign=discover_sexualities',
  },
  {
    displayOperator(_: Result): boolean {
      return true
    },
    name: 'monster',
    about: '次はあなたの「お仕事モンスター」を診断しませんか？',
    catch: 'モンスターキャリア診断',
    description:
      '働くことにモヤモヤしてない？心に秘めたモンスターが具現化し相性の良い生息地（職場）がわかる！？新感覚のモンスターキャリア診断で本当の貴方を知ろう。',
    actionName: '無料で診断',
    url: 'https://jobrainbow.jp/counsel',
  },
  {
    displayOperator(result: Result): boolean {
      if (result.genderIdentity.gender.name !== 'トランスジェンダー男性(FtM)' && result.genderIdentity.gender.name !== 'シスジェンダー男性') {
        return false
      }
      return (
        result.resultNames.includes('ゲイ') ||
        result.resultNames.includes('バイセクシュアル') ||
        result.resultNames.includes('ホモロマンティック') ||
        result.resultNames.includes('ホモセクシュアル')
      )
    },
    name: 'ambird',
    about: '同性同士で出会いたいあなたへ',
    catch: '日本初のＬＧＢＴ向けパートナー紹介サービス・リザライ',
    description:
      '同性を愛する方に『お見合い』の機会をセッティングし、将来に向けた真剣なパートナー探しをお手伝いするサービス。高い確率でマッチング成立を実現してきたコンシェルジュがベストパートナーと出会っていただくため紹介～交際までしっかりサポート。',
    actionName: 'パートナーを探す（無料）',
    url: 'https://www.resally.jp/link/jobrainbow/',
  },
  {
    displayOperator(result: Result): boolean {
      return result.resultNames.includes('ゲイ') || result.resultNames.includes('レズビアン')
    },
    name: 'resally',
    about: '同性同士で出会いたいあなたへ',
    catch: '日本初のＬＧＢＴ向けパートナー紹介サービス・リザライ',
    description:
      '同性を愛する方に『お見合い』の機会をセッティングし、将来に向けた真剣なパートナー探しをお手伝いするサービス。高い確率でマッチング成立を実現してきたコンシェルジュがベストパートナーと出会っていただくため紹介～交際までしっかりサポート。',
    actionName: 'パートナーを探す（無料）',
    url: 'https://www.resally.jp/link/jobrainbow/',
  },
  {
    displayOperator(result: Result): boolean {
      return shouldDisplayPiamy(result)
    },
    name: 'piamy',
    about: '安心できる出会いがほしいあなたへ',
    catch: '女性に惹かれる人、自分の性に迷う人の\nつながる居場所SNS「ピアミー」',
    description:
      'どんな「好き」のカタチも、今の自分のあり方もここでは大切にされます。\n' +
      '素敵な出会いがあった人が60%！\n' +
      '「始めて1ヶ月で恋人ができて幸せです」' +
      '「趣味の話で毎週電話する親友ができました」\n' +
      '「自分だけじゃないんだと安心しました」' +
      '「まだ出会えてないけどなんか楽しい！」\n\n' +
      '顔写真の登録不要、事前の本人確認制の安心空間です。',
    actionName: '詳しく見る',
    url: 'https://piamy.onelink.me/vHqh/dooo1ngl',
  },
]
